<template>
  <div id="jira-card">
    <div class="jira-result" :key="index"
      v-for="(result, index) in jiraResults"
    >
      <div class="jira-class" :id="`jira-item-${index}`">
        <div class="item-title" style="display:flex;">
          <div class="jira-title">
            <router-link :to="{
              path:`${routeKey}/issue/${result.key}`}"
              class="title-style" ref="routerLink"
              v-if="displayMethod !== 'single-ticket'"
            >
              {{ result.fields.summary }} ({{ result.key }})
            </router-link>
            <a class="title-style" ref="routerLink"
              v-if="displayMethod === 'single-ticket'"
            >
              {{ result.fields.summary }} ({{ result.key }})
            </a>
          </div>
        </div>
      </div>

      <div class="jira-content">
        <div class="jira-lines">
          <div class="content-sub-lines">
            <div class="content-title">Erstellt: </div>
            <div class="jira-info" id="createdDate">
              {{ renderDate(result.fields.created) }}
            </div>
          </div>
          <div class="content-sub-lines">
            <div class="content-title">Aktualisiert: </div>
            <div class="jira-info" id="updatedDate">
              {{ renderDate(result.fields.updated)  }}
            </div>
          </div>
          <div class="content-sub-lines">
            <div class="content-title">Status: </div>
            <div class="jira-info" id="status"
              :class="'sd-status sd-'
              + result.fields.status.statusCategory.colorName"
            >
              {{ result.fields.status.name }}
            </div>
          </div>
        </div>
        <div id="description" v-html="result.renderedFields.description"></div>
      </div>
      <div class="comments-wrapper">
        <div class="comments-button" v-if="preloadedComments === false">
          <div v-show="commentOpenedIndex != index"
            @click="openComment(index);
            searchComments(result, index);">Kommentare einblenden
            <img class="icon vertical expander"
              src="/static/material_icons/expand_more.png"
            />
          </div>
          <div v-show="commentOpenedIndex === index"
            @click="openComment(index);">Kommentare ausblenden
            <img class="icon vertical expander"
              src="/static/material_icons/expand_less.png"
            />
          </div>
        </div>
        <div class="jira-mail">
          <div @click="mailSubject(
              mailAddress,
              result.fields.summary,
              result.key)"
          >
            Kommentar hinzufügen +
          </div>
        </div>
      </div>
      <div id="comments-box"
        v-if="preloadedComments || commentOpenedIndex === index"
      >
        <div v-if="loadingCom && !commentResult.length" class="comment-spinner">
          <img src="/static/spinner.svg" height="40" width="40"/>
        </div>
        <div class="comment-elem"
          v-for="(result, index) in commentResult" :key="index"
        >
          <div class="comment-title">
            von <span>{{ result.author.displayName }}</span>
            hinzugefügt am
            {{ renderDate(result.updated) }}
          </div>
          <div class="comment-body"
            v-html="result.renderedBody"
          ></div>
        </div>
        <div :key="'no-result'" class="comment-title"
          v-if="commentResult.length === 0 && !loadingCom"
        >
          Es gibt keine Kommentare
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-restricted-globals: ["off", "screen"] */
import mixin from '../mixins/Mixins';
import store from '../../store/Store';

export default {
  name: 'jiraCard',
  mixins: [mixin],
  store,
  props: [
    'baseUrl',
    'mailAddress',
    'routeKey',
    'displayMethod',
    'preloadedResult',
    'preloadedComments',
  ],

  computed: {
    commentOpenedIndex() {
      return this.$store.state.commentOpenedIndex;
    },
    jiraResults() {
      if (this.preloadedResult) {
        return this.preloadedResult;
      }
      return this.$store.state.jiraResults;
    },
  },

  created() {
    this.defaultMail = this.$config.default.mailAddress;
  },

  data() {
    return {
      commentResult: this.preloadedComments || [],
      loadingCom: false,
    };
  },

  methods: {
    searchComments(result, index) {
      this.loadingCom = true;
      this.commentResult = [];
      setTimeout(() => this.queryComments(result, index), 300);
    },

    queryComments(result, index) {
      const queryComments =
        `/app/${this.routeKey}/jira/rest/api/2/issue/` +
        `${result.key}/comment?orderBy=-created&expand=renderedBody`;

      const self = this;
      axios({
        method: 'get',
        url: queryComments,
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.total > 0) {
          this.commentResult = response.data.comments;
        } else {
          this.commentResult = [];
          self.$nextTick(() => {
            this.scrollJiraDiv(index);
          });
        }
        this.loadingCom = false;
      }).catch((error) => {
        this.logError(error);
      });
    },

    openComment(index) {
      if (this.commentOpenedIndex === index) {
        this.$store.commit('SET_COMMENT_OPENED_INDEX', -1);
      } else {
        this.$store.commit('SET_COMMENT_OPENED_INDEX', index);
      }
    },

    mailSubject(mailConfig, title, key) {
      const mailTo = mailConfig || this.defaultMail;
      window.location.href = `${mailTo}?subject=${title} (${key})`;
    },

    scrollJiraDiv(index) {
      this.$el.querySelector(`#jira-item-${index}`).scrollIntoView();
      window.scrollBy(0, -160);
    },
  },
};
</script>

<style lang="scss">
@import "./../../Globals.scss";

#jira-card {
  max-width:$sd-max-width;
  margin: auto;
  padding-bottom: 15px;
}

.confluenceTable {
  border-collapse: collapse;
  margin: 5px 0 5px 2px;
  width: auto
}

td {
  border: 1px solid #ccc;
  padding: 3px 4px 3px 4px;
  display: table-cell;
  vertical-align: inherit;
}

.jira-class {
  padding-top: 25px;
}

.jira-class a:hover {
  color: $sd-color-dark-blue;
  opacity: 0.8;
}

.jira-content {
  word-break: break-word;
  margin: 10px 5% 0 5%;
  text-align: left;
}

.jira-content a, .jira-content a:visited {
  color: $sd-color-blue;
}

.jira-content img {
  max-width: 100%;
}

.padding-content {
  margin-top: 15px;
}

.jira-result {
  box-shadow: $sd-box-shadow;
  background: #ffffff;
  margin-bottom: 40px;
}

.jira-mail {
  display: inline-block;
  cursor: pointer;
  padding: 7px 4%;
  color: $sd-color-blue;
  font-weight: bold;
}

.jira-mail div:hover > p {
  color: $sd-color-dark-blue;
  opacity: 0.8;
}

.comments-wrapper {
  padding-top: 5px;
  margin: auto;
  max-width: 50%;
}

.jira-lines {
  display: table;
  width: 100%;
}

.content-sub-lines {
  display: inline-block;
  vertical-align: top;
  width: 32%;
}

.content-title {
  display: inline-block;
  padding-right: 10px;
  font-weight: bold;
}

.jira-info {
  display: inline-block;
  max-width: 75%;
  word-wrap: break-word;
  padding: 2px 4px;
}

.description-title {
  font-weight: bold;
  padding-bottom: 10px;
}

.comments-title {
  padding: 10px 0 10px 0;
  font-weight: bold;
}

#comments-box {
  padding: 0 0 0 0;
}

.comments-button {
  display: inline-block;
}

.comments-button > div {
  background-color: $sd-color-blue;
  padding: 5px 10px;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
}

.comment-spinner {
  background: #EEE;
  text-align: center;
}

.comment-title {
  text-align: left;
  padding: 10px 5%;
  background: #EEE;
}
.comment-title span {
  color: $sd-color-blue;
}

.comment-body {
  padding: 0 5% 10px;
  text-align: left;
  word-wrap: break-word;
}

.comment-body a {
  color: $sd-color-blue;
}

.comment-body img {
  max-width: 100%;
}

@media (max-width: 720px) {
  .description-title {
    font-size: 11px;
  }

  .content-title,
  .comments-title {
    font-size: 11px;
  }

  .content-title {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// JiraCard.vue?015b492f